import { useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { ENDPOINT_PATH } from '../../config';

const CropModal = ({ image, onCrop, onClose }) => {
    const [crop, setCrop] = useState();
    const imgRef = useRef(null);

    const calculateAspectRatio = () => {
        const frameSizeStr = localStorage.getItem("FRAME_SIZE");
        if (!frameSizeStr || frameSizeStr === "undefined") {
            return undefined; // Default aspect when no frame size is selected yet
        }

        try {
            const frameSize = JSON.parse(frameSizeStr);
            const aspectRatio = frameSize.width / frameSize.height;
            if (getOrientation() === 1) {
                return aspectRatio;
            }
            return 1 / aspectRatio;
        } catch (e) {
            console.error("Failed to parse", e);
            return undefined;
        }
    }
    const getOrientation = () => {
        const orientationStr = localStorage.getItem("FRAME_ORIENTATION");

        if (!orientationStr || orientationStr === "undefined") {
            return undefined;
        }

        try {
            const orientation = JSON.parse(orientationStr);
            if (orientation === "portrait") {
                return 1;
            }
            return 0;
        } catch (e) {
            console.error("Failed to parse orientation", e);
            // Fallback just in case it wasn't saved as JSON somehow
            if (orientationStr === "portrait") {
                return 1;
            }
            return 0;
        }
    }

    const handleCropComplete = () => {
        if (!crop || !imgRef.current) {
            onClose();
            return;
        }

        const canvas = document.createElement('canvas');
        const imageDef = imgRef.current;
        const scaleX = imageDef.naturalWidth / imageDef.width;
        const scaleY = imageDef.naturalHeight / imageDef.height;

        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            imageDef,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        canvas.toBlob((blob) => {
            if (blob) {
                // Set name if blob is returning from a File
                blob.name = 'cropped.jpeg';
                onCrop(blob);
            }
            onClose();
        }, 'image/jpeg');
    };

    // Safely handle if image is a File/Blob or a string URL. Proxy string URLs to prevent CORS issues.
    const imageSrc = image instanceof File || image instanceof Blob
        ? URL.createObjectURL(image)
        : (image?.startsWith('http') ? `${ENDPOINT_PATH}/api/proxy-image?url=${encodeURIComponent(image)}` : image);

    return (
        <Modal show={true} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Crop Image</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
                {image ? (
                    <ReactCrop
                        crop={crop}
                        onChange={(c) => setCrop(c)}
                        ruleOfThirds={true}
                        aspect={calculateAspectRatio()}>
                        <img
                            ref={imgRef}
                            src={imageSrc}
                            alt="Crop Preview"
                            style={{ maxHeight: '60vh', maxWidth: '100%' }}
                            crossOrigin="anonymous"
                        />
                    </ReactCrop>
                ) : (
                    <p>No image available</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleCropComplete}>
                    Crop & Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CropModal;